import type { EntityTypeMeta } from './EntityTypeMeta'
import type { HasPrice } from './HasPrice'

export default function isEntityTypeMetaHasPrice(
  entityTypeMeta: EntityTypeMeta
): entityTypeMeta is EntityTypeMeta & HasPrice {
  return (entityTypeMeta as HasPrice).price > 0
}
